import React, { useState } from "react";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const DownloadModal = ({ isdownloadopen, setisdownloadopen }) => {
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const handleCheckboxChange1 = () => {
    setIsChecked1(!isChecked1);
  };
  const handleCheckboxChange2 = () => {
    setIsChecked2(!isChecked2);
  };
  const handleCheckboxChange3 = () => {
    setIsChecked3(!isChecked3);
  };
  const handleOk = () => {
    setisdownloadopen(false);
  };
  const handleCancel = () => {
    setisdownloadopen(false);
  };
  return (
    <>
      <Modal
        open={isdownloadopen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="download-modal"
        centered={true}
        width="30%"
      >
        <form>
          <div className="modal-content">
            <div className="v-center space-between">
              <div></div>
              <h2 className="fw-bold text-medium-black text-center">
                Download
              </h2>
              <Icon
                icon="streamline:delete-1-solid"
                width={16}
                height={16}
                color="#fff"
                className="cross- cursor-pointer"
                onClick={handleCancel}
              />
            </div>

            <div className="download-modal-inner d-flex flex-column ">
              <div className="check-txt-div v-center space-between">
                <div className="files-div v-center gap-3">
                  <img src="../../assets/icons/pdfIcon.png" alt="pdf" />
                  <h6> .pdf</h6>
                </div>
                <div className="check-me-div ">
                  <input
                    type="checkbox"
                    id="customCheckboxSelectAll1"
                    style={{ display: "none" }}
                    checked={isChecked1}
                    onChange={handleCheckboxChange1}
                  />
                  <label
                    htmlFor="customCheckboxSelectAll1"
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: isChecked1 ? "#435AB8 " : "transparent",
                      }}
                    >
                      {isChecked1 && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                </div>
              </div>
              <div className="check-txt-div v-center space-between">
                <div className="files-div v-center gap-3">
                  <img src="../../assets/icons/jpejicon.png" alt="jpejicon" />
                  <h6> .jpeg</h6>
                </div>
                <div className="check-me-div ">
                  <input
                    type="checkbox"
                    id="customCheckboxSelectAll2"
                    style={{ display: "none" }}
                    checked={isChecked2}
                    onChange={handleCheckboxChange2}
                  />
                  <label
                    htmlFor="customCheckboxSelectAll2"
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: isChecked2 ? "#435AB8 " : "transparent",
                      }}
                    >
                      {isChecked2 && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                </div>
              </div>
              <div className="check-txt-div v-center space-between">
                <div className="files-div v-center gap-3">
                  <img src="../../assets/icons/docIcon.png" alt="docIcon" />
                  <h6> .doc</h6>
                </div>
                <div className="check-me-div ">
                  <input
                    type="checkbox"
                    id="customCheckboxSelectAll3"
                    style={{ display: "none" }}
                    checked={isChecked3}
                    onChange={handleCheckboxChange3}
                  />
                  <label
                    htmlFor="customCheckboxSelectAll3"
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: isChecked3 ? "#435AB8 " : "transparent",
                      }}
                    >
                      {isChecked3 && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div className="keywords-div h-center v-center gap-3 w-100 ">
              <label className=" keyword-selected fw-normal text-white v-center h-center cursor-pointer d-flex gap-2 px-3">
                <Icon
                  icon="ph:download-fill"
                  width={25}
                  height={30}
                  className="file-icon"
                />
                Download
              </label>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default DownloadModal;
